(() => {
  if (window.__variantOptionFocus) return;
  window.__variantOptionFocus = true;

  document.addEventListener(
    'click',
    (event) => {
      const label = event.target.closest?.('.variant-picker label[for]');
      if (!label) return;

      const control = document.getElementById(label.getAttribute('for'));
      if (!control?.hasAttribute('data-option-position')) return;

      // The click lands on the label, so at capture time focus is still on <body> and this
      // becomes a programmatic focus. Chrome rings those as keyboard focus, which showed up as
      // a stray accent-coloured circle on round swatches. detail === 0 means the click was
      // synthesised from the keyboard, which is the only case that should keep the ring.
      control.focus({ preventScroll: true, focusVisible: event.detail === 0 });
    },
    true,
  );
})();
